import React from 'react';
import { Icon, List } from 'semantic-ui-react';
import { Ordine, OrdineRiga, StatoOrdine } from '../models';
import { getStatoValues } from '../utility';
import parse from 'html-react-parser';

export const numeroDocumentoFormatterComputer = (value: any): string => {
    return value === 0 ? '' : String(value);
}

export const numeroDocumentoFormatterMobile = (value: any): JSX.Element => {
    return value === 0 ? <></> : <>{'n.'} <b>{String(value)}</b></>;
}

export const statoOrdineFormatter = (value: any) => {
    const stato = getStatoValues(value as StatoOrdine);
    return (
        <>
            <Icon name={stato.name} color={stato.color} />
            {stato.text}
        </>
    );
}

export const materialiFormatter = (_: any, ordine: Ordine) => {
    return (
        <List.List>
            {ordine.righe.map(riga => riga.quantita > 0 ? renderMateriale(riga) : <></>)}
        </List.List>
    )
}

const renderMateriale = (riga: OrdineRiga) => {
    return (
        <List.Item key={riga.codice}>
            <List.Icon name='file' style={{color: riga.colore}}/>
            <strong>{riga.quantita}</strong> {riga.descrizione}
        </List.Item>
    )
}

export const ubicazioneFormatter = (value: any): string | JSX.Element => {
    const ubicazione = value as string;
    if (ubicazione) {
        return parse(ubicazione) as JSX.Element;
    }
    return "";
}

/*const renderMateriale = (materiale: keyof Consumabili, qta: number) => {
    const valore = getConsumabileNameByProp(materiale);
    return (
        <List.Item key={materiale}>
            <List.Icon name='file' color={valore.color} />
            <strong>{qta}</strong> {valore.nome}
        </List.Item>
    );
}*/